import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=4971eb6c&scoped=true&"
import script from "./ShoppingList.vue?vue&type=script&lang=js&"
export * from "./ShoppingList.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingList.vue?vue&type=style&index=0&id=4971eb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971eb6c",
  null
  
)

/* custom blocks */
import block0 from "./ShoppingList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports